/**
 * Uses dipatcher 'redraw' event to wire up the group member item in the list.
 */

import PaginatorView from 'component/paginator/paginator'
import CreateActivityCTAView from 'component/cta/create_activity/create_activity'
import GoToEventsCTAView from 'component/cta/go_to_events/go_to_events'
import template from 'component/paginator/template/whiteBox.tmpl'
import View from 'view/view'
import dispatcher from 'service/event_dispatcher'

const ItemView = View.extend({
    render() {
        this.$el.html(this.model.get('markup'))
        dispatcher.dispatch('redraw', this.$el)
        return this
    },
})

export default PaginatorView.extend({
    template,

    renderItem(model) {
        const view = this.initSubview(ItemView, { model })
        view.render()
        return view
    },

    renderEmptyMessage() {
        return this.initSubview(this.options.isMember ? CreateActivityCTAView : GoToEventsCTAView, {
            className: 'whiteBox__section',
            activityGroupId: this.options.activityGroupId,
        }).render()
    },
})
